/* eslint-disable */
// PrimeVue passthrough preset

var c = {
    input: "w-full bg-white border border-stone-300 rounded-xl px-4 py-2.5 text-sm text-navy outline-none transition-all focus:border-teal focus:ring-2 focus:ring-teal/20 placeholder:text-navy/30",
    inputInvalid: "w-full bg-white border border-red-400 rounded-xl px-4 py-2.5 text-sm text-navy outline-none transition-all focus:ring-2 focus:ring-red-400/20 placeholder:text-navy/30",
    btnBase: "inline-flex items-center justify-center gap-2 font-medium rounded-xl transition-all cursor-pointer select-none disabled:opacity-50 disabled:cursor-not-allowed",
    btnMd: "px-4 py-2 text-sm",
    btnSm: "px-3 py-1.5 text-xs",
    btnLg: "px-6 py-3 text-sm",
    btnPrimary: "bg-navy text-offwhite hover:bg-navy-mid",
    btnSecondary: "bg-stone-100 text-navy border border-stone-300 hover:bg-stone-200",
    btnDanger: "bg-red-500 text-white hover:bg-red-600",
    btnSuccess: "bg-teal text-offwhite hover:bg-teal/90",
    btnInfo: "bg-navy-light text-offwhite hover:bg-navy-hover",
    btnWarn: "bg-yellow-500 text-white hover:bg-yellow-600",
    btnText: "bg-transparent text-navy hover:bg-navy/5",
    optSelected: "px-4 py-2.5 text-sm text-teal bg-teal/10 font-medium cursor-pointer",
    optNormal: "px-4 py-2.5 text-sm text-navy hover:bg-stone-100 cursor-pointer transition-colors",
    panel: "absolute z-50 mt-1 w-full bg-white border border-stone-300 rounded-xl shadow-lg overflow-hidden",
    filterWrap: "relative p-2 border-b border-stone-200",
    hdrCell: "bg-navy text-offwhite text-xs font-semibold uppercase tracking-wide px-4 py-3 text-left",
    bodyCell: "text-navy px-4 py-3 border-b border-navy/5 text-sm",
    rowEven: "transition-colors hover:bg-stone-200 bg-offwhite",
    rowOdd: "transition-colors hover:bg-stone-200 bg-stone-100",
    tagBase: "inline-flex items-center font-medium text-[10px] uppercase tracking-wide rounded-full px-2.5 py-1 border",
    tagSuccess: "bg-teal/10 text-teal border-teal/25",
    tagDanger: "bg-red-500/10 text-red-600 border-red-500/25",
    tagWarn: "bg-yellow-400/10 text-yellow-700 border-yellow-400/25",
    tagInfo: "bg-navy/10 text-navy border-navy/20",
    tagDefault: "bg-stone-100 text-navy/60 border-stone-300",
    toastBase: "pointer-events-auto flex items-center gap-2 px-3 py-2 rounded-lg shadow-md min-w-[220px] max-w-xs border text-xs",
    toastSuccess: "bg-teal/10 border-teal/30 text-teal",
    toastError: "bg-red-50 border-red-200 text-red-700",
    toastWarn: "bg-yellow-50 border-yellow-200 text-yellow-700",
    toastInfo: "bg-navy/5 border-navy/20 text-navy",
    msgSuccess: "flex items-center gap-2 px-4 py-3 rounded-xl text-sm bg-teal/10 border border-teal/30 text-teal",
    msgError: "flex items-center gap-2 px-4 py-3 rounded-xl text-sm bg-red-50 border border-red-200 text-red-700",
    msgWarn: "flex items-center gap-2 px-4 py-3 rounded-xl text-sm bg-yellow-50 border border-yellow-200 text-yellow-700",
    msgInfo: "flex items-center gap-2 px-4 py-3 rounded-xl text-sm bg-navy/5 border border-navy/20 text-navy",
    dlgContent: "bg-offwhite rounded-2xl shadow-2xl w-full max-h-[90vh] overflow-y-auto",
    dlgHeader: "bg-navy text-offwhite px-6 py-4 rounded-t-2xl flex items-center justify-between border-b-2 border-teal",
    dlgFooter: "bg-stone-100 px-6 py-4 rounded-b-2xl flex justify-end gap-2",
    stepActive: "w-8 h-8 rounded-full flex items-center justify-center text-xs font-bold border-2 transition-all bg-teal border-teal text-offwhite",
    stepDone: "w-8 h-8 rounded-full flex items-center justify-center text-xs font-bold border-2 transition-all bg-teal/20 border-teal text-teal",
    stepIdle: "w-8 h-8 rounded-full flex items-center justify-center text-xs font-bold border-2 transition-all bg-offwhite border-stone-300 text-navy/40",
    tabActive: "px-4 py-2.5 text-sm font-medium cursor-pointer border-b-2 -mb-px text-teal border-teal",
    tabIdle: "px-4 py-2.5 text-sm font-medium cursor-pointer border-b-2 -mb-px text-navy/50 border-transparent hover:text-navy",
    pageActive: "w-8 h-8 rounded flex items-center justify-center text-xs cursor-pointer bg-teal text-offwhite font-semibold",
    pageIdle: "w-8 h-8 rounded flex items-center justify-center text-xs cursor-pointer text-navy/60 hover:bg-navy/10",
    calDay: "text-center py-1 rounded cursor-pointer text-navy hover:bg-stone-100",
    calDaySelected: "text-center py-1 rounded cursor-pointer bg-teal text-offwhite font-medium",
    calDayToday: "text-center py-1 rounded cursor-pointer bg-teal/10 text-teal font-medium",
    checkOn: "w-4 h-4 rounded border-2 bg-teal border-teal flex items-center justify-center",
    checkOff: "w-4 h-4 rounded border-2 bg-white border-stone-300 hover:border-teal flex items-center justify-center",
    incrBtn: "absolute right-0 top-0 h-1/2 px-2 text-navy/50 hover:text-navy border-l border-t border-stone-300 flex items-center justify-center cursor-pointer",
    decrBtn: "absolute right-0 bottom-0 h-1/2 px-2 text-navy/50 hover:text-navy border-l border-stone-300 flex items-center justify-center cursor-pointer"
}

function sz(size) {
    if (size === "large") return c.btnLg
    if (size === "small") return c.btnSm
    return c.btnMd
}

export default {
    button: {
        root: function(p) {
            var base = c.btnBase + " " + sz(p.props.size)
            if (p.props.text) return {
                class: base + " " + c.btnText
            }
            var sev = p.props.severity
            if (sev === "secondary" || p.props.outlined) return {
                class: base + " " + c.btnSecondary
            }
            if (sev === "danger") return {
                class: base + " " + c.btnDanger
            }
            if (sev === "success") return {
                class: base + " " + c.btnSuccess
            }
            if (sev === "info") return {
                class: base + " " + c.btnInfo
            }
            if (sev === "warn" || sev === "warning") return {
                class: base + " " + c.btnWarn
            }
            return {
                class: base + " " + c.btnPrimary
            }
        },
        label: {
            class: "font-medium"
        },
        icon: {
            class: "text-sm"
        },
        loadingIcon: {
            class: "animate-spin text-sm"
        }
    },
    inputtext: {
        root: function(p) {
            return {
                class: p.props.invalid ? c.inputInvalid : c.input
            }
        }
    },
    textarea: {
        root: {
            class: c.input + " resize-none"
        }
    },
    password: {
        root: {
            class: "relative w-full"
        },
        pcInputText: {
            root: {
                class: c.input + " pr-10"
            }
        },
        maskIcon: {
            class: "absolute right-3 top-1/2 -translate-y-1/2 text-navy/40 cursor-pointer hover:text-navy"
        },
        unmaskIcon: {
            class: "absolute right-3 top-1/2 -translate-y-1/2 text-navy/40 cursor-pointer hover:text-navy"
        },
        overlay: {
            class: "hidden"
        }
    },
    checkbox: {
        root: {
            class: "inline-flex items-center cursor-pointer"
        },
        box: function(p) {
            return {
                class: p.props.modelValue ? c.checkOn : c.checkOff
            }
        },
        icon: {
            class: "text-white text-[10px]"
        }
    },
    select: {
        root: {
            class: "relative w-full flex items-center"
        },
        label: {
            class: c.input + " pr-8 cursor-pointer flex items-center flex-1"
        },
        dropdown: {
            class: "absolute right-3 top-1/2 -translate-y-1/2 text-navy/40 pointer-events-none flex items-center"
        },
        dropdownIcon: {
            class: "text-navy/40 text-xs"
        },
        overlay: {
            class: "z-[9999] min-w-[12rem] bg-white border border-stone-300 rounded-xl shadow-lg overflow-hidden"
        },
        listContainer: {
            class: "max-h-60 overflow-y-auto"
        },
        list: {
            class: "py-1"
        },
        option: function(p) {
            return {
                class: p.context && p.context.selected ? c.optSelected : c.optNormal
            }
        },
        optionLabel: function(p) {
            return {
                class: p.context && p.context.selected ? c.optSelected : c.optNormal
            }
        },
        pcFilter: {
            root: {
                class: c.input + " text-xs py-1.5 pl-8"
            }
        },
        filterIcon: {
            class: "absolute left-4 top-1/2 -translate-y-1/2 text-navy/40 text-xs pointer-events-none"
        },
        pcFilterContainer: {
            class: c.filterWrap
        },
        emptyMessage: {
            class: "px-4 py-3 text-sm text-navy/40 text-center"
        },
        transition: {
            enterFromClass: "opacity-0 -translate-y-1",
            enterActiveClass: "transition-all duration-150",
            leaveActiveClass: "transition-all duration-100",
            leaveToClass: "opacity-0 -translate-y-1"
        }
    },
    multiselect: {
        root: {
            class: "relative w-full flex items-center"
        },
        labelContainer: {
            class: "flex-1 overflow-hidden"
        },
        label: {
            class: c.input + " pr-8 cursor-pointer flex flex-wrap gap-1 min-h-[42px] flex-1"
        },
        chipItem: {
            class: "inline-flex items-center gap-1 bg-teal text-offwhite text-xs px-2 py-0.5 rounded-full"
        },
        dropdown: {
            class: "absolute right-3 top-1/2 -translate-y-1/2 text-navy/40 pointer-events-none flex items-center"
        },
        dropdownIcon: {
            class: "text-navy/40 text-xs"
        },
        overlay: {
            class: "z-[9999] min-w-[12rem] bg-white border border-stone-300 rounded-xl shadow-lg overflow-hidden"
        },
        listContainer: {
            class: "max-h-60 overflow-y-auto"
        },
        list: {
            class: "py-1"
        },
        optionLabel: function(p) {
            return {
                class: p.context && p.context.selected ? c.optSelected : c.optNormal
            }
        },
        pcFilter: {
            root: {
                class: c.input + " text-xs py-1.5 pl-8"
            }
        },
        filterIcon: {
            class: "absolute left-4 top-1/2 -translate-y-1/2 text-navy/40 text-xs pointer-events-none"
        },
        pcFilterContainer: {
            class: c.filterWrap
        },
        header: {
            class: "px-4 py-2 border-b border-stone-200 flex items-center gap-2"
        },
        emptyMessage: {
            class: "px-4 py-3 text-sm text-navy/40 text-center"
        },
        transition: {
            enterFromClass: "opacity-0 -translate-y-1",
            enterActiveClass: "transition-all duration-150",
            leaveActiveClass: "transition-all duration-100",
            leaveToClass: "opacity-0 -translate-y-1"
        }
    },
    datepicker: {
        root: {
            class: "relative w-full"
        },
        pcInputText: {
            root: {
                class: c.input + " pr-10"
            }
        },
        // PrimeVue v4 — l'icône est rendue via un bouton dropdown intégré
        inputIconContainer: {
            class: "hidden"
        },
        dropdownIcon: {
            class: "text-navy/40"
        },
        dropdown: {
            class: "absolute right-0 top-0 h-full px-3 flex items-center justify-center text-navy/40 hover:text-navy cursor-pointer bg-transparent border-0 rounded-r-xl"
        },
        panel: {
            class: "z-[9999] mt-1 bg-white border border-stone-200 rounded-2xl shadow-xl p-4 w-[280px]"
        },
        calendarContainer: {
            class: "w-full"
        },
        calendar: {
            class: "w-full"
        },
        header: {
            class: "flex items-center justify-between mb-3"
        },
        pcPrevButton: {
            root: {
                class: "w-8 h-8 flex items-center justify-center rounded-lg text-navy/50 hover:bg-stone-100 hover:text-navy transition-colors cursor-pointer border-0 bg-transparent"
            }
        },
        pcNextButton: {
            root: {
                class: "w-8 h-8 flex items-center justify-center rounded-lg text-navy/50 hover:bg-stone-100 hover:text-navy transition-colors cursor-pointer border-0 bg-transparent"
            }
        },
        title: {
            class: "flex items-center gap-1 text-sm font-semibold text-navy"
        },
        selectMonth: {
            class: "text-sm font-semibold text-navy hover:text-teal cursor-pointer transition-colors bg-transparent border-0 p-0"
        },
        selectYear: {
            class: "text-sm font-semibold text-navy hover:text-teal cursor-pointer transition-colors bg-transparent border-0 p-0"
        },
        dayView: {
            class: "w-full border-collapse"
        },
        tableHeader: {
            class: ""
        },
        tableHeaderRow: {
            class: ""
        },
        weekDayCell: {
            class: "w-9 pb-1"
        },
        weekDay: {
            class: "w-9 h-7 flex items-center justify-center text-[11px] font-semibold text-navy/40 uppercase"
        },
        tableBody: {
            class: ""
        },
        tableBodyRow: {
            class: ""
        },
        dayCell: {
            class: "p-0.5"
        },
        day: function(p) {
            var ctx = p.context
            if (!ctx) return {
                class: "w-8 h-8 flex items-center justify-center rounded-lg text-sm cursor-pointer text-navy hover:bg-stone-100 transition-colors"
            }
            if (ctx.selected) return {
                class: "w-8 h-8 flex items-center justify-center rounded-lg text-sm cursor-pointer bg-teal text-offwhite font-semibold"
            }
            if (ctx.today) return {
                class: "w-8 h-8 flex items-center justify-center rounded-lg text-sm cursor-pointer bg-teal/10 text-teal font-semibold hover:bg-teal/20 transition-colors"
            }
            if (ctx.disabled) return {
                class: "w-8 h-8 flex items-center justify-center rounded-lg text-sm text-navy/20 cursor-not-allowed"
            }
            if (ctx.otherMonth) return {
                class: "w-8 h-8 flex items-center justify-center rounded-lg text-sm cursor-pointer text-navy/25 hover:bg-stone-50 transition-colors"
            }
            return {
                class: "w-8 h-8 flex items-center justify-center rounded-lg text-sm cursor-pointer text-navy hover:bg-stone-100 transition-colors"
            }
        },
        monthView: {
            class: "grid grid-cols-3 gap-2 mt-2"
        },
        month: function(p) {
            var ctx = p.context
            if (ctx && ctx.selected) return {
                class: "px-2 py-1.5 rounded-lg text-xs font-semibold text-center cursor-pointer bg-teal text-offwhite"
            }
            return {
                class: "px-2 py-1.5 rounded-lg text-xs font-medium text-center cursor-pointer text-navy hover:bg-stone-100 transition-colors"
            }
        },
        yearView: {
            class: "grid grid-cols-3 gap-2 mt-2"
        },
        year: function(p) {
            var ctx = p.context
            if (ctx && ctx.selected) return {
                class: "px-2 py-1.5 rounded-lg text-xs font-semibold text-center cursor-pointer bg-teal text-offwhite"
            }
            return {
                class: "px-2 py-1.5 rounded-lg text-xs font-medium text-center cursor-pointer text-navy hover:bg-stone-100 transition-colors"
            }
        },
        transition: {
            enterFromClass: "opacity-0 -translate-y-1",
            enterActiveClass: "transition-all duration-150",
            leaveActiveClass: "transition-all duration-100",
            leaveToClass: "opacity-0 -translate-y-1"
        }
    },
    calendar: {
        root: {
            class: "relative w-full"
        },
        pcInputText: {
            root: {
                class: c.input + " pr-10"
            }
        },
        inputIconContainer: {
            class: "hidden"
        },
        dropdownIcon: {
            class: "text-navy/40"
        },
        dropdown: {
            class: "absolute right-0 top-0 h-full px-3 flex items-center justify-center text-navy/40 hover:text-navy cursor-pointer bg-transparent border-0 rounded-r-xl"
        },
        panel: {
            class: "z-[9999] mt-1 bg-white border border-stone-200 rounded-2xl shadow-xl p-4 w-[280px]"
        },
        calendarContainer: {
            class: "w-full"
        },
        calendar: {
            class: "w-full"
        },
        header: {
            class: "flex items-center justify-between mb-3"
        },
        pcPrevButton: {
            root: {
                class: "w-8 h-8 flex items-center justify-center rounded-lg text-navy/50 hover:bg-stone-100 hover:text-navy transition-colors cursor-pointer border-0 bg-transparent"
            }
        },
        pcNextButton: {
            root: {
                class: "w-8 h-8 flex items-center justify-center rounded-lg text-navy/50 hover:bg-stone-100 hover:text-navy transition-colors cursor-pointer border-0 bg-transparent"
            }
        },
        title: {
            class: "flex items-center gap-1 text-sm font-semibold text-navy"
        },
        selectMonth: {
            class: "text-sm font-semibold text-navy hover:text-teal cursor-pointer transition-colors bg-transparent border-0 p-0"
        },
        selectYear: {
            class: "text-sm font-semibold text-navy hover:text-teal cursor-pointer transition-colors bg-transparent border-0 p-0"
        },
        dayView: {
            class: "w-full border-collapse"
        },
        tableHeader: {
            class: ""
        },
        tableHeaderRow: {
            class: ""
        },
        weekDayCell: {
            class: "w-9 pb-1"
        },
        weekDay: {
            class: "w-9 h-7 flex items-center justify-center text-[11px] font-semibold text-navy/40 uppercase"
        },
        tableBody: {
            class: ""
        },
        tableBodyRow: {
            class: ""
        },
        dayCell: {
            class: "p-0.5"
        },
        day: function(p) {
            var ctx = p.context
            if (!ctx) return {
                class: "w-8 h-8 flex items-center justify-center rounded-lg text-sm cursor-pointer text-navy hover:bg-stone-100 transition-colors"
            }
            if (ctx.selected) return {
                class: "w-8 h-8 flex items-center justify-center rounded-lg text-sm cursor-pointer bg-teal text-offwhite font-semibold"
            }
            if (ctx.today) return {
                class: "w-8 h-8 flex items-center justify-center rounded-lg text-sm cursor-pointer bg-teal/10 text-teal font-semibold hover:bg-teal/20 transition-colors"
            }
            if (ctx.disabled) return {
                class: "w-8 h-8 flex items-center justify-center rounded-lg text-sm text-navy/20 cursor-not-allowed"
            }
            if (ctx.otherMonth) return {
                class: "w-8 h-8 flex items-center justify-center rounded-lg text-sm cursor-pointer text-navy/25 hover:bg-stone-50 transition-colors"
            }
            return {
                class: "w-8 h-8 flex items-center justify-center rounded-lg text-sm cursor-pointer text-navy hover:bg-stone-100 transition-colors"
            }
        },
        monthView: {
            class: "grid grid-cols-3 gap-2 mt-2"
        },
        month: function(p) {
            var ctx = p.context
            if (ctx && ctx.selected) return {
                class: "px-2 py-1.5 rounded-lg text-xs font-semibold text-center cursor-pointer bg-teal text-offwhite"
            }
            return {
                class: "px-2 py-1.5 rounded-lg text-xs font-medium text-center cursor-pointer text-navy hover:bg-stone-100 transition-colors"
            }
        },
        yearView: {
            class: "grid grid-cols-3 gap-2 mt-2"
        },
        year: function(p) {
            var ctx = p.context
            if (ctx && ctx.selected) return {
                class: "px-2 py-1.5 rounded-lg text-xs font-semibold text-center cursor-pointer bg-teal text-offwhite"
            }
            return {
                class: "px-2 py-1.5 rounded-lg text-xs font-medium text-center cursor-pointer text-navy hover:bg-stone-100 transition-colors"
            }
        },
        transition: {
            enterFromClass: "opacity-0 -translate-y-1",
            enterActiveClass: "transition-all duration-150",
            leaveActiveClass: "transition-all duration-100",
            leaveToClass: "opacity-0 -translate-y-1"
        }
    },
    inputnumber: {
        root: {
            class: "relative w-full"
        },
        pcInputText: {
            root: {
                class: c.input + " pr-16"
            }
        },
        buttonGroup: {
            class: "absolute right-0 top-0 h-full flex flex-col border-l border-stone-300 overflow-hidden rounded-r-xl"
        },
        incrementButton: {
            class: c.incrBtn
        },
        decrementButton: {
            class: c.decrBtn
        }
    },
    dialog: {
        mask: {
            class: "fixed inset-0 z-50 flex items-center justify-center bg-navy/70 backdrop-blur-sm"
        },
        root: {
            class: "bg-offwhite rounded-[20px] shadow-xl w-full max-w-lg flex flex-col max-h-[90vh] overflow-hidden"
        },
        header: {
            class: c.dlgHeader
        },
        title: {
            class: "text-sm font-bold text-offwhite"
        },
        headerActions: {
            class: "flex items-center gap-2"
        },
        pcCloseButton: {
            root: {
                class: "text-offwhite/60 hover:text-offwhite transition-colors p-1 rounded bg-transparent border-0 cursor-pointer"
            }
        },
        content: {
            class: "px-6 py-5 flex-1 overflow-y-auto"
        },
        footer: {
            class: c.dlgFooter
        },
        transition: {
            enterFromClass: "opacity-0 scale-95",
            enterActiveClass: "transition-all duration-200 ease-out",
            leaveActiveClass: "transition-all duration-150 ease-in",
            leaveToClass: "opacity-0 scale-95"
        }
    },
    toast: {
        root: {
            class: "fixed bottom-4 right-4 z-[9999] flex flex-col gap-1.5 pointer-events-none"
        },
        message: function(p) {
            // PrimeVue v4: severity is at p.props.severity or p.message.severity
            var sev = (p.props && p.props.severity) ||
                (p.message && p.message.severity) ||
                (p.props && p.props.message && p.props.message.severity)
            if (sev === "success") return {
                class: c.toastBase + " " + c.toastSuccess
            }
            if (sev === "error") return {
                class: c.toastBase + " " + c.toastError
            }
            if (sev === "warn") return {
                class: c.toastBase + " " + c.toastWarn
            }
            return {
                class: c.toastBase + " " + c.toastInfo
            }
        },
        messageIcon: {
            class: "text-sm flex-shrink-0 flex items-center"
        },
        messageContent: {
            class: "flex-1 min-w-0 flex flex-col justify-center"
        },
        summary: {
            class: "font-semibold text-[11px] leading-tight"
        },
        detail: {
            class: "text-[11px] opacity-80 truncate leading-tight"
        },
        closeButton: {
            class: "ml-1 opacity-50 hover:opacity-100 cursor-pointer flex-shrink-0 bg-transparent border-0 p-0 flex items-center justify-center w-4 h-4"
        },
        closeIcon: {
            class: "text-[10px]"
        },
        transition: {
            enterFromClass: "opacity-0 translate-x-4",
            enterActiveClass: "transition-all duration-200 ease-out",
            leaveActiveClass: "transition-all duration-150 ease-in",
            leaveToClass: "opacity-0 translate-x-4"
        }
    },
    datatable: {
        root: {
            class: "w-full"
        },
        table: {
            class: "w-full border-collapse text-sm"
        },
        thead: {
            class: ""
        },
        tbody: {
            class: ""
        },
        headerRow: {
            class: ""
        },
        headerCell: {
            class: c.hdrCell
        },
        bodyRow: function(p) {
            return {
                class: (p.context && p.context.index % 2 === 0) ? c.rowEven : c.rowOdd
            }
        },
        bodyCell: {
            class: c.bodyCell
        },
        emptyMessage: {
            class: "text-center text-navy/40 py-10 text-sm"
        },
        wrapper: {
            class: "overflow-x-auto rounded-2xl overflow-hidden"
        },
        loadingOverlay: {
            class: "absolute inset-0 bg-offwhite/70 flex items-center justify-center z-10"
        },
        loadingIcon: {
            class: "text-teal text-2xl animate-spin"
        },
        pcPaginator: {
            root: {
                class: "flex items-center justify-between flex-wrap gap-2 px-4 py-3 bg-stone-50 border-t border-stone-200 rounded-b-[14px]"
            },
            content: {
                class: "flex items-center gap-1"
            },
            first: {
                class: "w-8 h-8 flex items-center justify-center rounded-md text-navy/60 hover:bg-navy hover:text-offwhite transition-colors disabled:opacity-30 disabled:cursor-not-allowed cursor-pointer border-0 bg-transparent"
            },
            prev: {
                class: "w-8 h-8 flex items-center justify-center rounded-md text-navy/60 hover:bg-navy hover:text-offwhite transition-colors disabled:opacity-30 disabled:cursor-not-allowed cursor-pointer border-0 bg-transparent"
            },
            next: {
                class: "w-8 h-8 flex items-center justify-center rounded-md text-navy/60 hover:bg-navy hover:text-offwhite transition-colors disabled:opacity-30 disabled:cursor-not-allowed cursor-pointer border-0 bg-transparent"
            },
            last: {
                class: "w-8 h-8 flex items-center justify-center rounded-md text-navy/60 hover:bg-navy hover:text-offwhite transition-colors disabled:opacity-30 disabled:cursor-not-allowed cursor-pointer border-0 bg-transparent"
            },
            pages: {
                class: "flex items-center gap-1"
            },
            page: function(p) {
                return {
                    class: "w-8 h-8 flex items-center justify-center rounded-md text-xs font-medium transition-colors cursor-pointer border-0 " + ((p.context && p.context.active) ? "bg-teal text-offwhite" : "bg-transparent text-navy/60 hover:bg-navy hover:text-offwhite")
                }
            },
            pcRowPerPageDropdown: {
                root: {
                    class: "relative inline-flex items-center cursor-pointer"
                },
                label: {
                    class: "bg-white border border-stone-300 rounded-md text-navy text-xs px-3 py-1.5 pr-7 cursor-pointer flex items-center min-w-[70px]"
                },
                dropdown: {
                    class: "absolute right-2 top-1/2 -translate-y-1/2 text-navy/40 pointer-events-none"
                },
                dropdownIcon: {
                    class: "text-navy/40 text-xs"
                },
                overlay: {
                    class: "z-[9999] bg-white border border-stone-300 rounded-xl shadow-lg overflow-hidden min-w-[80px]"
                },
                listContainer: {
                    class: "max-h-48 overflow-y-auto"
                },
                list: {
                    class: "py-1"
                },
                option: function(p) {
                    return {
                        class: (p.context && p.context.selected ? "px-3 py-2 text-xs text-teal bg-teal/10 font-medium" : "px-3 py-2 text-xs text-navy hover:bg-stone-100") + " cursor-pointer"
                    }
                }
            },
            currentPageReport: {
                class: "text-xs text-navy/50 px-2"
            }
        }
    },
    column: {
        headerCell: {
            class: c.hdrCell
        },
        bodyCell: {
            class: c.bodyCell
        },
        sortIcon: {
            class: "ml-1 text-offwhite/60 text-xs"
        }
    },
    tag: {
        root: function(p) {
            var sev = p.props.severity
            if (sev === "success") return {
                class: c.tagBase + " " + c.tagSuccess
            }
            if (sev === "danger") return {
                class: c.tagBase + " " + c.tagDanger
            }
            if (sev === "warning") return {
                class: c.tagBase + " " + c.tagWarn
            }
            if (sev === "info") return {
                class: c.tagBase + " " + c.tagInfo
            }
            return {
                class: c.tagBase + " " + c.tagDefault
            }
        }
    },
    card: {
        root: {
            class: "bg-white rounded-2xl shadow-sm border border-stone-200 overflow-hidden"
        },
        header: {
            class: "px-6 pt-6"
        },
        body: {
            class: "px-6 py-6"
        },
        title: {
            class: "text-lg font-bold text-navy mb-1"
        },
        subtitle: {
            class: "text-sm text-navy/50 mb-4"
        },
        content: {
            class: ""
        },
        footer: {
            class: "px-6 pb-6 pt-0"
        }
    },
    paginator: {
        root: {
            class: "flex items-center justify-between flex-wrap gap-2 px-4 py-3 bg-stone-50 border-t border-stone-200 rounded-b-[14px]"
        },
        content: {
            class: "flex items-center gap-1"
        },
        first: {
            class: "w-8 h-8 flex items-center justify-center rounded-md text-navy/60 hover:bg-navy hover:text-offwhite transition-colors disabled:opacity-30 disabled:cursor-not-allowed cursor-pointer border-0 bg-transparent"
        },
        prev: {
            class: "w-8 h-8 flex items-center justify-center rounded-md text-navy/60 hover:bg-navy hover:text-offwhite transition-colors disabled:opacity-30 disabled:cursor-not-allowed cursor-pointer border-0 bg-transparent"
        },
        next: {
            class: "w-8 h-8 flex items-center justify-center rounded-md text-navy/60 hover:bg-navy hover:text-offwhite transition-colors disabled:opacity-30 disabled:cursor-not-allowed cursor-pointer border-0 bg-transparent"
        },
        last: {
            class: "w-8 h-8 flex items-center justify-center rounded-md text-navy/60 hover:bg-navy hover:text-offwhite transition-colors disabled:opacity-30 disabled:cursor-not-allowed cursor-pointer border-0 bg-transparent"
        },
        pages: {
            class: "flex items-center gap-1"
        },
        page: function(p) {
            return {
                class: "w-8 h-8 flex items-center justify-center rounded-md text-xs font-medium transition-colors cursor-pointer border-0 " + ((p.context && p.context.active) ? "bg-teal text-offwhite" : "bg-transparent text-navy/60 hover:bg-navy hover:text-offwhite")
            }
        },
        pcRowPerPageDropdown: {
            root: {
                class: "relative inline-flex items-center cursor-pointer"
            },
            label: {
                class: "bg-white border border-stone-300 rounded-md text-navy text-xs px-3 py-1.5 pr-7 cursor-pointer flex items-center min-w-[70px]"
            },
            dropdown: {
                class: "absolute right-2 top-1/2 -translate-y-1/2 text-navy/40 pointer-events-none"
            },
            dropdownIcon: {
                class: "text-navy/40 text-xs"
            },
            overlay: {
                class: "z-[9999] bg-white border border-stone-300 rounded-xl shadow-lg overflow-hidden min-w-[80px]"
            },
            listContainer: {
                class: "max-h-48 overflow-y-auto"
            },
            list: {
                class: "py-1"
            },
            option: function(p) {
                return {
                    class: (p.context && p.context.selected ? "px-3 py-2 text-xs text-teal bg-teal/10 font-medium" : "px-3 py-2 text-xs text-navy hover:bg-stone-100") + " cursor-pointer"
                }
            }
        },
        currentPageReport: {
            class: "text-xs text-navy/50 px-2"
        }
    },
    skeleton: {
        root: {
            class: "bg-navy-mid rounded animate-pulse"
        }
    },
    progressbar: {
        root: {
            class: "h-2 bg-navy/10 rounded-full overflow-hidden"
        },
        value: {
            class: "h-full bg-teal rounded-full transition-all"
        }
    },
    progressspinner: {
        root: {
            class: "w-8 h-8"
        },
        circle: {
            class: "stroke-teal"
        }
    },
    menu: {
        root: {
            class: "bg-white border border-stone-200 rounded-xl shadow-lg py-1 min-w-[160px]"
        },
        menuitem: {
            class: ""
        },
        content: {
            class: "px-4 py-2 text-sm text-navy hover:bg-stone-100 cursor-pointer transition-colors"
        },
        separator: {
            class: "border-t border-stone-200 my-1"
        }
    },
    confirmdialog: {
        icon: {
            class: "text-yellow-500 text-xl flex-shrink-0"
        },
        message: {
            class: "text-sm text-navy/70"
        },
        pcRejectButton: {
            root: {
                class: c.btnBase + " " + c.btnMd + " " + c.btnSecondary
            }
        },
        pcAcceptButton: {
            root: {
                class: c.btnBase + " " + c.btnMd + " " + c.btnDanger
            }
        }
    },
    divider: {
        root: {
            class: "flex items-center my-4"
        },
        content: {
            class: "px-3 text-xs text-navy/40 bg-offwhite"
        },
        beforeContainer: {
            class: "flex-1 border-t border-stone-200"
        },
        afterContainer: {
            class: "flex-1 border-t border-stone-200"
        }
    },
    badge: {
        root: {
            class: "inline-flex items-center justify-center min-w-[1.25rem] h-5 px-1.5 rounded-full bg-teal text-offwhite text-[10px] font-bold"
        }
    },
    chip: {
        root: {
            class: "inline-flex items-center gap-1.5 bg-stone-100 text-navy text-xs px-3 py-1 rounded-full border border-stone-300"
        },
        removeIcon: {
            class: "text-navy/50 hover:text-navy cursor-pointer"
        }
    },
    message: {
        root: function(p) {
            var sev = p.props.severity
            if (sev === "success") return {
                class: c.msgSuccess
            }
            if (sev === "error") return {
                class: c.msgError
            }
            if (sev === "warn") return {
                class: c.msgWarn
            }
            return {
                class: c.msgInfo
            }
        },
        icon: {
            class: "text-base flex-shrink-0"
        },
        text: {
            class: "flex-1"
        },
        closeButton: {
            class: "ml-2 opacity-60 hover:opacity-100 cursor-pointer"
        }
    },
    fileupload: {
        root: {
            class: "w-full"
        },
        buttonbar: {
            class: "flex gap-2 mb-3"
        },
        content: {
            class: "border-2 border-dashed border-stone-300 rounded-xl p-6 text-center text-navy/40 text-sm"
        }
    },
    panel: {
        root: {
            class: "bg-white rounded-2xl border border-stone-200 overflow-hidden"
        },
        header: {
            class: "bg-navy text-offwhite px-5 py-3 flex items-center justify-between"
        },
        title: {
            class: "text-sm font-semibold text-offwhite"
        },
        content: {
            class: "p-5"
        }
    },
    tabview: {
        root: {
            class: "w-full"
        },
        navContainer: {
            class: "border-b border-stone-200"
        },
        nav: {
            class: "flex gap-0 list-none p-0 m-0"
        },
        tabpanel: {
            class: "pt-4"
        }
    },
    tabpanel: {
        header: {
            class: ""
        },
        headerAction: function(p) {
            return {
                class: (p.context && p.context.active) ? c.tabActive : c.tabIdle
            }
        },
        content: {
            class: "py-4"
        }
    },
    steps: {
        root: {
            class: "flex items-center w-full mb-6"
        },
        menu: {
            class: "flex items-center w-full list-none p-0 m-0"
        },
        menuitem: {
            class: "flex-1 flex items-center"
        },
        action: {
            class: "flex flex-col items-center gap-1 cursor-pointer"
        },
        step: function(p) {
            if (p.context && p.context.active) return {
                class: c.stepActive
            }
            if (p.context && p.context.completed) return {
                class: c.stepDone
            }
            return {
                class: c.stepIdle
            }
        },
        label: function(p) {
            if (p.context && p.context.active) return {
                class: "text-[10px] font-medium mt-1 text-teal"
            }
            if (p.context && p.context.completed) return {
                class: "text-[10px] font-medium mt-1 text-teal/70"
            }
            return {
                class: "text-[10px] font-medium mt-1 text-navy/40"
            }
        },
        separator: {
            class: "flex-1 h-0.5 bg-stone-300 mx-2"
        }
    },
    scrollpanel: {
        root: {
            class: "overflow-auto"
        },
        barX: {
            class: "h-1.5 bg-navy/10 rounded-full"
        },
        barY: {
            class: "w-1.5 bg-navy/10 rounded-full"
        }
    }
}